// Historial de una regla con el historial común: fecha, evento, versión que dejó y quién lo hizo.
import { LifecycleHistory, toLifecycleEvent } from '@/shared/patterns/Lifecycle';
import { useRuleHistory } from '../../api/commissionQueries';

export function RuleHistoryList({ ruleId }: { ruleId: string }) {
    const history = useRuleHistory(ruleId);
    const events = history.data?.events ?? [];
    return (
        <LifecycleHistory
            title="Historial de esta regla"
            isLoading={history.isLoading}
            error={history.isError ? 'No se pudo leer el historial.' : null}
            onRetry={() => {
                void history.refetch();
            }}
            emptyText="Sin eventos registrados para esta regla"
            entries={events.map((event, index) => ({
                id: `${event.at}-${String(index)}`,
                at: event.at,
                event: toLifecycleEvent(event.action),
                eventLabel: event.action,
                detail: event.version === null ? undefined : `v${String(event.version)}`,
                actor: event.performedBy,
            }))}
        />
    );
}
